/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';
import { RULE_TYPE_NAME } from 'pages/user-preferences/utils/constant';
import { CatalogService } from './catalogService';
import { BudgetAmount } from './budgetAmount';
import { RuleRequestors } from './ruleRequestors';

export const RuleValue = ({ index }) => {
    const [order] = useRecoilState(OrderPayload);

    const renderComponent = () => {
        switch (order?.ruleRows?.[index]?.ruleType) {
            case RULE_TYPE_NAME?.TRUSTED_REQUESTOR:
                return <RuleRequestors index={index} />;
            case RULE_TYPE_NAME?.CATALOG:
                return <CatalogService index={index} />;
            case RULE_TYPE_NAME?.BUDGET_AMOUNT:
                return <BudgetAmount index={index} />;
            default:
                return <RuleRequestors index={index} />;
        }
    };

    return (
        <>
            <Box>{renderComponent()}</Box>
        </>
    );
};

RuleValue.propTypes = {
    index: PropTypes.number.isRequired,
};

export default React.memo(RuleValue);
